import { render, staticRenderFns } from "./Envelope.vue?vue&type=template&id=110e5561"
import script from "./Envelope.vue?vue&type=script&lang=js"
export * from "./Envelope.vue?vue&type=script&lang=js"
import style0 from "./Envelope.vue?vue&type=style&index=0&id=110e5561&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports